import { usePageView as useZionPageView } from '@fs/zion-analytics'

export default function usePageView(pageDetail) {
  return useZionPageView({ page_detail: pageDetail })
}
